import React from 'react';
import { useTranslation } from 'react-i18next';

import { isDefault } from '../../../utils/template';

import { addBallIndicatorIfNeeded, getBallIndicator, hasBallIndicator } from './Balls/Balls';

function Matches({ lotterySlug, matches }) {
    const { t } = useTranslation();

    function getBalls(match, ballClass, rangeIndex) {
        const balls = [];
        for (let i = 0; i < match; i++) {
            const isFirstBonusBall = rangeIndex === 1 && i === 0;
            const additionalClass = isDefault() && isFirstBonusBall ? ' first-bonus-ball' : '';

            balls.push(
                <div
                    key={match + i}
                    className={`ball-sm ball-${ballClass}${additionalClass}`}
                >
                    {addBallIndicatorIfNeeded(lotterySlug, rangeIndex)}
                </div>
            );
        }

        return balls;
    }

    return (
        <div>
            <div className={`row ${isDefault() ? 'g-0 d-flex prize-balls-container' : ''}`}>
                {getBalls(matches[0], '0', 0)}
                {typeof matches[1] === 'number' && getBalls(matches[1], '1', 1)}
                {typeof matches[2] === 'number' && getBalls(matches[2], '1', 2)}
            </div>
            <p className="name">
                {t('prizes.match')} {matches[0] > 0 ? matches[0] : ''}
                {typeof matches[1] === 'number' &&
                    matches[1] > 0 &&
                    ` ${matches[0] > 0 ? '+' : ''} ${
                        hasBallIndicator(lotterySlug, 1) ? getBallIndicator(lotterySlug, 1) : matches[1]
                    }`}
                {typeof matches[2] === 'number' &&
                    matches[2] > 0 &&
                    ` ${matches[0] > 0 ? '+' : ''} ${
                        hasBallIndicator(lotterySlug, 2) ? getBallIndicator(lotterySlug, 2) : matches[2]
                    }`}
            </p>
        </div>
    );
}

export default Matches;
